import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Signin from '../views/Signin.vue'
import CatalogManager from '../views/CatalogManager.vue'
import PromotionalOffers from '../views/PromotionalOffers.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/signin',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/:id/promotional-offers/:productId',
    name: 'PromotionalOffers',
    component: PromotionalOffers
  },
  {
    path: '/:id',
    name: 'CatalogManager',
    component: CatalogManager
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
